import React from 'react';

import BufferOptions from 'buffers/BufferOptions';
import MoleculeCanonicalSMILES from 'chemistry/molecules/tabs/MoleculeCanonicalSmiles';
import MoleculeChemicalFormula from 'chemistry/molecules/tabs/MoleculeChemicalFormula';
import MoleculeChemicalStructure, {
  MoleculeChemicalStructureSize,
} from 'chemistry/molecules/tabs/MoleculeChemicalStructure';
import {Molecule} from 'chemistry/molecules/tabs/MoleculeFileState';
import MoleculeFormDetails from 'chemistry/molecules/tabs/MoleculeFormDetails';
import DataConnector from 'connect/DataConnector';

export interface ConnectedMoleculeChemicalStructureTabProps {
  moleculeVersionId: string;
}

export interface UnconnectedMoleculeChemicalStructureTabProps {
  moleculeId: string;
  molecule: Molecule;
}

export type MoleculeChemicalStructureTabProps = ConnectedMoleculeChemicalStructureTabProps &
  UnconnectedMoleculeChemicalStructureTabProps;

class MoleculeChemicalStructureTabConnector extends DataConnector<
  UnconnectedMoleculeChemicalStructureTabProps,
  ConnectedMoleculeChemicalStructureTabProps
> {
  enhanceProps(): ConnectedMoleculeChemicalStructureTabProps {
    const moleculeVersionId =
      this.reduxState().ui.chemistry.moleculeVersionUIs[this.props.moleculeId].moleculeVersionId;
    return {moleculeVersionId};
  }
}

function MoleculeChemicalStructureTab(props: MoleculeChemicalStructureTabProps): JSX.Element {
  return (
    <div className="chemical-structure-tab">
      {props.molecule.getBannerText() != null && <BufferOptions banner={props.molecule.getBannerText()} />}
      <div className="react-tab-container">
        <MoleculeChemicalStructure
          {...props}
          size={MoleculeChemicalStructureSize.FULL_SIZE}
          editable={props.molecule.allowChemicalStructureEdits()}
          expandable={true}
        />
        <MoleculeChemicalFormula {...props} />
        <MoleculeCanonicalSMILES {...props} />
        <MoleculeFormDetails {...props} />
      </div>
    </div>
  );
}

const ConnectedMoleculeChemicalStructureTab = MoleculeChemicalStructureTabConnector.connect(
  MoleculeChemicalStructureTab
);
export default ConnectedMoleculeChemicalStructureTab;
